function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21778"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 4561",
    style: {
      fill: "#fff",
      stroke: "#e0e0df",
      strokeWidth: ".5px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 168,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 167.5,
    height: 167.5,
    rx: 9.75,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.75 20.25h-18v-18a2.25 2.25 0 0 0-4.5 0v18h-18a2.25 2.25 0 0 0 0 4.5h18v18a2.25 2.25 0 1 0 4.5 0v-18h18a2.25 2.25 0 1 0 0-4.5zm0 0",
    transform: "translate(62 62)",
    style: {
      fill: "#7c7c7c",
      stroke: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.46cf89faa725220449364f63584cce14.svg";
export { ForwardRef as ReactComponent };